import React from "react";
import { connect } from "react-redux";
import { Modal, Button, FormControl } from "react-bootstrap";
import Select from "react-select";
import "react-select/dist/react-select.css";

import Colors from "../../styles/colors";
import {
  addWatchlistItem,
  editWatchlistItem,
  deleteWatchlistItem
} from "../user-data/UserDataState";
import glamorous from "glamorous";

class WatchlistModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedLocation: null,
      selectedPart: ""
    };
  }

  componentWillReceiveProps(nextProps) {
    const { watchlistItem } = nextProps;

    this.setState({
      selectedLocation:
        watchlistItem && watchlistItem.location_id
          ? watchlistItem.location_id
          : null,
      selectedPart:
        watchlistItem &&
        watchlistItem.part_value &&
        watchlistItem.part_value.length > 0
          ? watchlistItem.part_value
          : ""
    });
  }

  render() {
    const {
      watchlistItem,
      show,
      hide,
      locations,
      addWatchlistItem,
      editWatchlistItem,
      deleteWatchlistItem
    } = this.props;
    const { selectedLocation, selectedPart } = this.state;

    const locationOptions = locations.map(l => {
      return {
        value: l.id,
        label: l.code + ":  " + l.name + ", " + l.city + ", " + l.state
      };
    });

    return (
      <Modal show={show} onHide={() => hide()}>
        <Modal.Header
          closeButton
          style={{
            padding: "0.5em",
            color: Colors.background.DARK_BLUE,
            backgroundColor: Colors.background.LIGHT_GRAY
          }}
        >
          <Modal.Title style={{ fontWeight: "300" }}>
            {watchlistItem != null
              ? "Edit My Watchlist Item"
              : "Add to My Watchlist"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ backgroundColor: Colors.background.LIGHT_GRAY }}>
          <glamorous.P css={{ fontWeight: "bold" }}>
            Select a location and/or a part number to add to your watchlist.
          </glamorous.P>

          <glamorous.Div
            style={{
              color: "#999",
              paddingBottom: "0.5em",
              paddingTop: "0.5em"
            }}
          >
            {"Location"}
          </glamorous.Div>
          <Select
            options={locationOptions}
            simpleValue
            name="selected-state"
            value={selectedLocation}
            onChange={v => this.setState({ selectedLocation: v })}
          />

          <glamorous.P
            css={{
              display: "flex",
              flex: 1,
              justifyContent: "center",
              paddingTop: "1.5em",
              color: "#999"
            }}
          >
            and/or
          </glamorous.P>

          <glamorous.Div style={{ color: "#999", paddingBottom: "0.5em" }}>
            {"Part #"}
          </glamorous.Div>
          <FormControl
            style={{
              backgroundColor: "white",
              height: "3em",
              boxShadow: "none"
            }}
            type="text"
            value={selectedPart || ""}
            placeholder={"Input Part #"}
            onChange={evt => this.setState({ selectedPart: evt.target.value })}
          />
        </Modal.Body>
        <Modal.Footer style={{ backgroundColor: "#e2e2e2" }}>
          {watchlistItem != null && (
            <Button
              style={{
                position: "absolute",
                backgroundColor: Colors.highlight.RED,
                color: "white",
                left: "1em"
              }}
              onClick={() => {
                deleteWatchlistItem(watchlistItem.id);
                hide();
              }}
            >
              Delete
            </Button>
          )}
          <Button
            style={{
              backgroundColor: "white",
              color: Colors.background.DARK_BLUE,
              marginRight: "0.5em"
            }}
            onClick={() => hide()}
          >
            Cancel
          </Button>
          <Button
            style={{
              backgroundColor: Colors.highlight.GREEN,
              color: "white",
              fontWeight: "300"
            }}
            onClick={() => {
              if (watchlistItem != null) {
                editWatchlistItem(
                  watchlistItem.id,
                  selectedPart,
                  selectedLocation
                );
              } else {
                addWatchlistItem(selectedPart, selectedLocation);
              }

              hide();
            }}
          >
            {watchlistItem != null ? "Update" : "Add to My Watchlist"}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    locations: state.locations.data
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addWatchlistItem: (parts, locations) =>
      dispatch(addWatchlistItem(parts, locations)),
    editWatchlistItem: (id, parts, locations) =>
      dispatch(editWatchlistItem(id, parts, locations)),
    deleteWatchlistItem: id => dispatch(deleteWatchlistItem(id))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WatchlistModal);



// WEBPACK FOOTER //
// ./src/modules/shipment-status/WatchlistModal.js